import {
    ColorType,
    LineStyle,
    createChart
} from "lightweight-charts";
import { Dictionary } from "motw_core/Utils/Dictionary";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import { IStateProgressChartState } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/ProgressChart/IStateProgressChartState";
import { DrawLineSeries } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Chart/Line/DrawLineSeries";
import { SetChartZoomBasedOnViewport } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Chart/Zoom/SetChartZoomToLastYear";
import { IMappedData } from "../../IMappedData";
import { AddVerticalLinesToChart } from "./AddVerticalLineToChart";

export function DrawChart(state: IStateProgressChartState) {
    if (!state.isOpen || state.dwkc_emotionCharacterCounts === undefined) {
        return;
    }

    const charts = [
        Draw(`stateDominance_container`, state.dominanceDictionary!),
        Draw(`stateProgress_container`, state.countsDictionary!),
    ];

    return () => charts.forEach((chart) => chart.remove());
}

function Draw(divId: string, dictionary: Dictionary<string, IMappedData[]>) {
    const chart = createChart(divId, {
        layout: {
            background: {
                type: ColorType.VerticalGradient,
                topColor: `black`,
                bottomColor: `#181b1f`,
            },
            textColor: `white`,
        },
        grid: {
            vertLines: { color: "#4B4B4B", style: LineStyle.SparseDotted },
            horzLines: { color: "#4B4B4B", style: LineStyle.SparseDotted },
        },
    });

    var dictionaryKeys = dictionary.GetKeys();

    var allLineSeries = dictionaryKeys.map((element) =>
        DrawLineSeries(chart, Emotions.GetFromCharacter(element), dictionary)
    );

    AddVerticalLinesToChart(chart, allLineSeries[0]);

    SetChartZoomBasedOnViewport(allLineSeries[0], chart);

    return chart;
}
